package org.hs_soft.runmynesto.domain.usecase.options.export

import org.hs_soft.runmynesto.domain.model.home.options.export.cash_reigster_gloabal_info.CashRegisterGlobalModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.export.CashReigsterGloabalRepository

class CashRegisterGlobalUseCase(
    private val cashRegisterGlobalRepository: CashReigsterGloabalRepository
) {
    suspend operator fun invoke(): CashRegisterGlobalModel {
        return cashRegisterGlobalRepository.getCashRegisterGlobal()
    }
} 